"use client";

import Link from "next/link";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const TopBreadCrumb = ({ hotel, loading} : { hotel: any, loading: boolean }) => {
  return (
    <section className="py-10 d-flex items-center bg-light-2">
      <div className="container">
        <div className="row y-gap-10 items-center justify-between">
          <div className="col-auto">
            {loading ? (
              <>
                <div className="row x-gap-10 y-gap-5 items-center text-14 text-light-1">
                  <div className="col-auto"> <Skeleton count={1} width={100} /></div>
                  {/* End .col-auto */}
                  <div className="col-auto"> <Skeleton count={1} width={100} /></div>
                  {/* End .col-auto */}
                  <div className="col-auto"> <Skeleton count={1}  width={100} /></div>
                  {/* End .col-auto */}
                  <div className="col-auto"> <Skeleton count={1} width={100} /></div>
                  {/* End .col-auto */}
                  <div className="col-auto">
                    <div className="text-dark-1"> <Skeleton count={1}  width={100} /></div>
                  </div>
                  {/* End .col-auto */}
                </div>
              </>
            ) : (
              <>
                <div className="row x-gap-10 y-gap-5 items-center text-14 text-light-1">
                  <div className="col-auto">
                  <Link href={"/"}>Home</Link>
                    
                  </div>
                  {/* { JSON.stringify(hotel)} */}
                  {/* End .col-auto */}
                  <div className="col-auto">&gt;</div>
                  {/* End .col-auto */}
                  <div className="col-auto">{hotel?.city}</div>
                  {/* End .col-auto */}
                  <div className="col-auto">&gt;</div>
                  {/* End .col-auto */}
                  <div className="col-auto">
                    <div className="text-dark-1">{hotel?.name}</div>
                  </div>
                  {/* End .col-auto */}
                </div>
              </>
            )}

            {/* End .row */}
          </div>
          {/* End .col-auto */}

          {/* <div className="col-auto">
            <a href="#" className="text-14 text-blue-1 underline">
              All Hotel in London
            </a>
          </div> */}
          {/* End col-auto */}
        </div>
        {/* End .row */}
      </div>
      {/* End .container */}
    </section>
  );
};

export default TopBreadCrumb;
